import { API_URL } from '../../../app-config/constants';
import type { CalendarConfigurationDto } from '../../react/features/Integrations/CalendarIntegration/types';
import { get, post, put } from '../request';

export function getCalendarIntegrationConfig(companyId?: string) {
    return get<CalendarConfigurationDto>(`${API_URL}/admin-calendar-integration`, { getData: { companyId } });
}

export function verifyGoogleConnection() {
    return put<boolean>(`${API_URL}/admin-calendar-integration/verify-google`);
}

export function removeProvider() {
    return post<void>(`${API_URL}/admin-calendar-integration/remove-provider`);
}
